module.exports = __webpack_public_path__ + "img/sorting-arrow-up.9e4f19bc.svg";